import React from "react";
import Typography from "@material-ui/core/Typography/Typography";
import { styles } from "./ImprintView.styles";
import { useTranslation } from "react-i18next";

import {
    WithStyles,
    withStyles,
} from "@material-ui/core";
import { CenteredContainer } from "../../components/CenteredContainer/CenteredContainer";

export interface IImprintViewProps extends WithStyles<typeof styles> {}

const ImprintViewPure: React.FunctionComponent<IImprintViewProps> = ({ classes }) => {
    const {t} = useTranslation();
    return <CenteredContainer>
        <div className={classes.title}>
            <Typography variant="h2">{t("footer.imprint.title")}</Typography>
            <Typography variant="h4">{t("general.address")}</Typography>
            <Typography variant="body1">Deutsche Börse AG<br></br>60485 Frankfurt/Main<br></br>{t("general.germany")}<br></br>{t("general.phone")}: +49-(0) 69-2 11-0<br></br>{t("general.fax")}: +49-(0) 69-2 11-1 20 05<br></br>{t("general.email")}: <a href="mailto:info@deutsche-boerse.com" target="_self">info@deutsche-boerse.com</a></Typography>
            <Typography variant="h4">{t("footer.imprint.members")}</Typography>
            <Typography variant="body1">Theodor Weimer (CEO)<br></br>Christoph Böhm<br></br>Thomas Book<br></br>Heike Eckert<br></br>Stephan Leithner<br></br>Gregor Pottmeyer</Typography>

            <Typography variant="h4">{t("footer.imprint.legalInfo")}</Typography>
            <Typography variant="body1">{t("footer.imprint.stockCorporation")}<br></br>Frankfurt/Main<br></br>HRB Nr. 32232<br></br>{t("footer.imprint.localCourt")} Frankfurt/Main<br></br>{t("footer.imprint.taxId")}: DE 114151950</Typography>

            <Typography variant="h4">{t("footer.imprint.responsibility")}</Typography>
            <Typography variant="body1">Market + Services<br></br>Marketing</Typography>

            <Typography variant="h4">{t("footer.imprint.disclaimerTitle")}</Typography>
            <Typography variant="body1">{t("footer.imprint.disclaimerText")}</Typography>
        </div>

    </CenteredContainer>;

};

export const ImprintView = withStyles(styles)(ImprintViewPure);
